import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navLinks = [
    { name: 'Home', href: '/' },
    {
      name: 'About Us',
      dropdown: [
        { name: 'Company Background', href: '/company-background' },
        // { name: 'Our Vision and Mission', href: '/about/vision-mission' },
        { name: 'Business Activity', href: '/business-activity' },
        { name: 'Organization Structure', href: '/organization-structure' },
        { name: 'CIDB/SSM', href: '/our-certificates' },
        { name: 'Google Location', href: '/contact' },
        { name: 'Get in Touch', href: '/contact' },
      ],
    },
    // {
    //   name: 'Our Expertise', href: '/OurExpertisePage 
      // dropdown: [
      //   { name: 'Metal Roofing', href: '/expertise/metal-roofing' },
      //   { name: 'Commercial Beam Structure and Roofing', href: '/expertise/commercial-beam' },
      //   { name: 'Awning ACP/Steel', href: '/expertise/awning' },
      //   { name: 'Steel Deck/Staircase', href: '/expertise/steel-deck' },
      //   { name: 'MS/SS Grating', href: '/expertise/ms-ss-grating' },
      //   { name: 'Metal Hoarding', href: '/expertise/metal-hoarding' },
      //   { name: 'MS/SS Hand Railing', href: '/expertise/ms-ss-hand-railing' },
      //   { name: 'Warehouse/Site Office', href: '/expertise/warehouse-site-office' },
      //   { name: 'Signage Wall', href: '/expertise/signage-wall' },
      //   { name: 'Fencing', href: '/expertise/fencing' },
      //   { name: 'Signboard Frame', href: '/expertise/signboard-frame' },
      //   { name: 'Security Gate', href: '/expertise/security-gate' },
      // ],
    // },
    //     { name: 'Project',
    //   dropdown: [
    //     { name: 'Client Project', href: '/project/client' },
    //     { name: 'Pictures of the Project', href: '/our-works' },
    //     { name: 'Work Promises', href: '/project/promises' },
        
    //   ],
    // },
    {
      name: 'News',
      dropdown: [
        { name: 'All News', href: '/news' },
        { name: 'Events', href: '/events' },
        // { name: 'HQ Project News', href: 'news-hq-project' },
        // { name: 'Tower News', href: '/news-hq-project' },
        // { name: 'Bridget Project News', href: '/news-hq-project' },
      ],
    },
    { name: 'Our Expertise', href: '/our-expertise' 
    },
    // { name: 'Projects', href: '/our-expertise' 
    // },
    { name: 'Machineries', href: '/machineries' 
    },
    { name: 'Landmark', href: '/our-works' 
    },
    { name: 'Contact', href: '/contact' 
    },
    // {
    //   name: 'Landmark',
    //   dropdown: [
    //     { name: 'HQ Project News', href: 'news-hq-project' },
    //     { name: 'Tower News', href: '/news-hq-project' },
    //     { name: 'Bridget Project News', href: '/news-hq-project' },
    //   ],
    // },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-[#364A9A] shadow-md py-2">
      <div className="container mx-auto flex justify-between items-center px-4">
        {/* Logo */}
        <a href="/" className="flex items-center text-base sm:text-lg md:text-xl font-bold font-['Poppins']">
          <img src="/logo/logo-01.png" alt="MK Metal & Engineering Works Logo" className="h-10 sm:h-12 mr-2" />
          <span className="text-white hidden sm:inline">MK Metal &</span>
          <span className="text-[#ECEE07] ml-1 hidden sm:inline">Engineering Works SDN.BHD</span>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-4 xl:space-x-8">
          {navLinks.map((link) => (
            link.dropdown ? (
              <div key={link.name} className="relative group">
                <button
                  className="text-white hover:text-[#ECEE07] transition-colors duration-300 flex items-center py-2"
                >
                  {link.name} <ChevronDown size={16} className="ml-1 group-hover:rotate-180 transition-transform duration-300" />
                </button>
                <div className="absolute left-0 mt-0 w-48 bg-[#364A9A] shadow-lg rounded-md py-2 z-30 hidden group-hover:block">
                  {link.dropdown.map((dropLink) => (
                    <a
                      key={dropLink.name}
                      href={dropLink.href}
                      className={`block px-4 py-2 transition-colors duration-300 ${currentPath === dropLink.href ? 'text-[#364A9A] bg-[#ECEE07]' : 'text-white hover:bg-[#ECEE07] hover:text-[#364A9A]'}`}
                    >
                      {dropLink.name}
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              <a
                key={link.name}
                href={link.href}
                className={`py-2 transition-colors duration-300 ${currentPath === link.href ? 'text-[#ECEE07]' : 'text-white hover:text-[#ECEE07]'}`}
              >
                {link.name}
              </a>
            )
          ))}
        </nav>

        {/* Mobile Menu Toggle */}
        <div className="lg:hidden">
          <button onClick={toggleMobileMenu} className="text-white focus:outline-none mr-4">
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-[#364A9A] z-40 flex flex-col items-center justify-center space-y-4 sm:space-y-6 pb-8">
          <button onClick={toggleMobileMenu} className="absolute top-4 right-4 text-white focus:outline-none mr-4">
            <X size={28} />
          </button>
          {navLinks.map((link) => (
            link.dropdown ? (
              <MobileDropdown key={link.name} link={link} toggleMobileMenu={toggleMobileMenu} currentPath={currentPath} />
            ) : (
              <a
                key={link.name}
                href={link.href}
                className={`text-xl sm:text-2xl font-bold transition-colors duration-300 py-9 ${currentPath === link.href ? 'text-[#ECEE07]' : 'text-white hover:text-[#ECEE07]'}`}
                onClick={toggleMobileMenu} // Close menu on link click
              >
                {link.name}
              </a>
            )
          ))}
        </div>
      )}
    </header>
  );
};

const MobileDropdown = ({ link, toggleMobileMenu, currentPath }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMobileDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="w-full text-center">
      <button
        className="text-white text-xl sm:text-2xl font-bold hover:text-[#ECEE07] transition-colors duration-300 flex items-center justify-center w-full py-2"
        onClick={handleMobileDropdownToggle}
      >
        {link.name} <ChevronDown size={24} className={`ml-2 ${isDropdownOpen ? 'rotate-180' : ''} transition-transform duration-300`} />
      </button>
      {isDropdownOpen && (
        <div className="mt-2 space-y-2">
          {link.dropdown.map((dropLink) => (
            <a
              key={dropLink.name}
              href={dropLink.href}
              className={`block px-4 py-2 text-base sm:text-lg transition-colors duration-300 ${currentPath === dropLink.href ? 'text-[#364A9A] bg-[#ECEE07]' : 'text-white hover:bg-[#ECEE07] hover:text-[#364A9A]'}`}
              onClick={toggleMobileMenu} // Close menu on link click
            >
              {dropLink.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default Header;
